import { render, staticRenderFns } from "./HomeNews.vue?vue&type=template&id=63f38e53&scoped=true&"
import script from "./HomeNews.vue?vue&type=script&lang=js&"
export * from "./HomeNews.vue?vue&type=script&lang=js&"
import style0 from "./HomeNews.vue?vue&type=style&index=0&id=63f38e53&prod&scoped=true&lang=css&"
import style1 from "./HomeNews.vue?vue&type=style&index=1&id=63f38e53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f38e53",
  null
  
)

export default component.exports